<template>
  <div class="policeInfo">
    <search-input @search="handleSearch"></search-input>
    <van-tabs v-model="active" sticky @change="handleChange">
      <van-tab title="全部" name>
        <div class="list">
          <policy-table
            v-for="item in policy"
            :key="item.id"
            :item="item"
            @click.native="togglePoliceDetail(item)"
          ></policy-table>
        </div>
      </van-tab>
      <van-tab title="养老政策" name="aged_policy">
        <policy-table
          v-for="item in policy"
          :key="item.id"
          :item="item"
          @click.native="togglePoliceDetail(item)"
        ></policy-table>
      </van-tab>
      <van-tab title="办事指南" name="guidance">
        <policy-table
          v-for="item in policy"
          :key="item.id"
          :item="item"
          @click.native="togglePoliceDetail(item)"
        ></policy-table>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { getPolicyList } from "@/api/home.js";
import { areaCode } from "@/common/constants.js";
import PolicyTable from "./policyTable";
export default {
  name: "PoliceInfo",
  data() {
    return {
      active: "",
      policy: [],
      searchWord:''
    };
  },
  components: {
    PolicyTable
  },
  methods: {
    togglePoliceDetail(item) {
      this.$router.push({
        name: "policeDetail",
        query: { id: item.id, title: item.title }
      });
    },
    handleChange(name) {
      this.getPolicy(name);
    },
    async getPolicy(classify2, title = this.searchWord) {
      const { data } = await getPolicyList({
        areaCode,
        classify2,
        title
      });
      this.policy = data.list;
    },
    handleSearch(val) {
      this.searchWord = val
      this.getPolicy("", val);
    }
  },
  mounted() {
    this.getPolicy();
  }
};
</script>

<style lang="scss" scoped>
.policeInfo {
  .van-tabs {
    ::v-deep {
      .van-tab__text{
        font-weight: 700;
        color: #7A7A7A;
      }
      .van-tab--active {
        background-color: #FFFFFF !important;
        .van-tab__text {
          color: #ffd63c !important;
        }
      }
      .van-tabs__line {
        background-color: #ffd63c;
      }
      .van-tab:nth-child(2n){
        background-color: #F1F1F1;
      }
      .van-tab:nth-child(2n+1){
        background-color: #E4E4E4;
      }
      .contain {
        border-bottom: 4px solid #fff8e9;
      }
    }
  }
}
</style>
